import LoginApi from "./resources/login";
import ProfileApi from "./resources/profile";
import UsersApi from "./resources/users";
import NavigationApi from "./resources/navigation";
import RoleApi from "./resources/roles";
import EnvironmentApi from "./resources/environment";
import ClickhouseServerApi from "@/api/resources/clickhouse-servers";
import NotificationsApi from "@/api/resources/notifications";
import ExplorerApi from "@/api/resources/explorer";
import ExportApi from "@/api/resources/export";
import LegacyDatabaseServerApi from "@/api/resources/legacy-database-servers";
import DimensionsApi from "@/api/resources/dimensions";
import AnnotatedEventsApi from "@/api/resources/annotated-events";
import AnnotatedEventCategories from "@/api/resources/annotated-event-categories";
import ResourceTreeNodes from "@/api/resources/resource-tree-nodes";
import CapacityEditorApi from "@/api/resources/capacity-editor";
import Hierarchy from "@/api/resources/hierarchy";
import AlertsApi from "@/api/resources/alerts";
import SegmentsApi from "@/api/resources/segments";
import DocumentsApi from "@/api/resources/documents";
import FileTagsApi from "@/api/resources/file-tags";
import ExportSchedulesApi from "@/api/resources/export-schedules";
import DashboardApi from "@/api/resources/dashboard";
import BookingExpertsApi from "@/api/resources/booking-experts";
import TestingApi from "@/api/resources/testing";
import RuleEngineApi from "@/api/resources/rule-engine";
import FileApi from "@/api/resources/files";
import AiAssist from "@/api/resources/ai-assist";
import Auth from "@/api/resources/auth";
import Integrations from "@/api/resources/integrations";
import ProLoyalty from "@/api/resources/pro-loyalty";
import AiReport from "@/api/resources/ai-report";
import CampaignPlannerAPI from "@/api/resources/campaign-planner";
import PqaApi from "@/api/resources/pqa";
import BasePriceApi from "@/api/resources/base-price";

class ApiClient {
	public login = new LoginApi();
	public profile = new ProfileApi();
	public users = new UsersApi();
	public navigation = new NavigationApi();
	public roles = new RoleApi();
	public environment = new EnvironmentApi();
	public clickhouseServer = new ClickhouseServerApi();
	public notifications = new NotificationsApi();
	public explorer = new ExplorerApi();
	public exports = new ExportApi();
	public legacyDatabaseServer = new LegacyDatabaseServerApi();
	public dimensions = new DimensionsApi();
	public annotatedEvents = new AnnotatedEventsApi();
	public annotatedEventCategories = new AnnotatedEventCategories();
	public resourceTreeNodes = new ResourceTreeNodes();
	public hierarchy = new Hierarchy();
	public alerts = new AlertsApi();
	public capacityEditor = new CapacityEditorApi();
	public segments = new SegmentsApi();
	public documents = new DocumentsApi();
	public fileTags = new FileTagsApi();
	public dashboard = new DashboardApi();
	public exportSchedules = new ExportSchedulesApi();
	public bookingExperts = new BookingExpertsApi();
	public testing = new TestingApi();
	public ruleEngine = new RuleEngineApi();
	public files = new FileApi();
	public aiAssist = new AiAssist();
	public aiReport = new AiReport();
	public auth = new Auth();
	public integrations = new Integrations();
	public proLoyalty = new ProLoyalty();
	public campaignPlanner = new CampaignPlannerAPI();
	public pqa = new PqaApi();
	public basePrice = new BasePriceApi();
}

export function useApiClient<K extends keyof ApiClient>(apiResource: K) {
	return new ApiClient()[apiResource];
}

export default ApiClient;
